import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Heading, Paragraph } from './Text';

import pien from '../assets/team-pien.png';
import bigPien from '../assets/team-pien@2x.png';

const Emphasis = styled.span`
	color: black;
`;

export function Advice(props: { title: string; description: string }) {
	const { t } = useTranslation();

	return (
		<Flex alignItems="center">
			<Box mr={4}>
				<Heading>{props.title}</Heading>
				<Paragraph my={2}>{props.description}</Paragraph>
				<Paragraph>
					- <Emphasis>Pien</Emphasis> {t('advice.from.at.company')} <Emphasis>Treams</Emphasis>
				</Paragraph>
			</Box>
			<Box>
				<img srcSet={`${pien} 124w, ${bigPien} 248w`} width="124px" alt="Pien van Treams" />
			</Box>
		</Flex>
	);
}
